module.exports = __webpack_public_path__ + "static/brauchtdich-org_logo-a3ce488822522399daa21396205fe2b6.png";